export default "__VITE_PUBLIC_ASSET__c627e00d__"